export const DEFAULT_SETTINGS = Object.freeze({
  loginAsOrg: false
});

export const getSettings = () => DEFAULT_SETTINGS;
